import { IToastPayload } from '@features/ToastManager/model/types';

const EVENT_NAME = 'app:toast';

const bus = new EventTarget();

export function emitToast(payload: IToastPayload) {
    bus.dispatchEvent(new CustomEvent<IToastPayload>(EVENT_NAME, { detail: payload }));
}

export function subscribeToast(handler: (payload: IToastPayload) => void) {
    const listener = (e: Event) => handler((e as CustomEvent<IToastPayload>).detail);
    bus.addEventListener(EVENT_NAME, listener);
    return () => bus.removeEventListener(EVENT_NAME, listener);
}
